module.exports = __webpack_public_path__ + "static/media/vikram.2e4aa22a.png";